/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
**/


//HRW-289 -getaway campaign ADA start
document.addEventListener("keydown", function(event) {

    if (document.getElementsByClassName('pop-formsection')[0].style.display === "block" && event.keyCode === 13) {
        document.getElementsByClassName('pop-formsection')[0].style.display = 'none';
        document.getElementsByClassName('container-pop')[0].style.display = 'none'; // To close the subscribe pop up in escape key event 
    } else if (document.getElementsByClassName('pop-formsection')[0].style.display === "block" && event.keyCode === 9) {
        event.preventDefault();
        if (document.activeElement.id === 'signup_close') {
            $('.learn-more').focus();
            $('.learn-more').attr("tabindex", 0);
        } else {
            $("#signup_close").focus(); // To focus the subscribe popup close button
            $("#signup_close").attr("tabindex", 0);
        }

    }
})
//HRW-289 -getaway campaign ADA end

//destop tab control
$(document).on('click', '[data-tab-nav-target]', function(event) {
  event.stopPropagation();
  event.preventDefault();
  var target= $(this).data('tab-nav-target');
  
  $('.productTabsNavItem').removeClass('is-active');
  $('.productTabsContent').removeClass('is-active');
  $(this).addClass('is-active');
  $('[data-tab-content-target="' + target + '"]').addClass('is-active');
});

//mobile tab control
$(document).on('click', '[data-target="mobile-tab"]', function(event){
  event.stopPropagation();
  event.preventDefault();
  if($(this).hasClass('is-active')){
    $(this).removeClass('is-active');
  } else {
    $('.productTabs-mobile-item.is-active').removeClass('is-active');
    $(this).addClass('is-active');  
  }
});

//destop tab control
$(document).on('keypress', '[data-tab-nav-target]', function(event){
  event.stopPropagation();
  event.preventDefault();
  var target= $(this).data('tab-nav-target');
  
  $('.productTabsNavItem').removeClass('is-active');
  $('.productTabsContent').removeClass('is-active');
  $(this).addClass('is-active');
  $('[data-tab-content-target="' + target + '"]').addClass('is-active');
});

//mobile tab control
$(document).on('keypress', '[data-target="mobile-tab"]', function(event){
  event.stopPropagation();
  event.preventDefault();
  if($(this).hasClass('is-active')){
    $(this).removeClass('is-active');
  } else {
    $('.productTabs-mobile-item.is-active').removeClass('is-active');
    $(this).addClass('is-active');  
  }
});

//when you click a [data-variant-target] element
$(document).on('click', '[data-variant-target]', function(e){
  //find the closest .ProductItem__Wrapper element
  var closestProductItem__Wrapper = $(this).closest('.ProductItem__Wrapper');
  //get the target of the variant that needs to be shown
  var variantTarget = $(this).data('variant-target');
 //get the variantImageSrc
  var variantImageSrc = $(this).data('variant-imagesrc');
  if(variantImageSrc.includes("no-image")){
    variantImageSrc = $(this).data('variant-orgimageirc');
  }

  var variantHasProducts = $(this).data('variant-hasproducts');
  var variantButtonContainer = closestProductItem__Wrapper.find('[data-role="button-container"]');
  variantButtonContainer.removeClass('is-sold-out');
  
  if(!variantHasProducts) {
    variantButtonContainer.addClass('is-sold-out');
  }
  
  //within the closestFrom element remove the class is-selected from any item that contains is-selected
  closestProductItem__Wrapper.find('.is-selected').removeClass('is-selected');
  //set the image
  closestProductItem__Wrapper.find('img').attr('srcset',variantImageSrc);
  //within the closestFrom element add the class is-selected to the target varient price 
  closestProductItem__Wrapper.find('[data-variant-price-target="'+variantTarget+'"]').addClass('is-selected');
});


//collection sub collection mobile nav
$(document).on('click', '.collections-collection-feed-responsive-heading', function(event){	 
  //get the closest feed container as a var
  var collectionContainer = $(this).closest('.collections-collection-feed');
  //check to see if the collectionContainer is already open
  var collectionContainerAlreadyOpen = collectionContainer.hasClass('is-open');
  //if its already open, just close it
  if(collectionContainerAlreadyOpen) {
    collectionContainer.removeClass('is-open');
  //if collectionContainerAlreadyOpen is not true
  } else {
    //close any open collections-collection-feed
	$('.collections-collection-feed').removeClass('is-open');
    //open this collections-collection-feed
    collectionContainer.addClass('is-open');
  }  
});

var urlParams = new URLSearchParams(location.search);
var collectionTarget = urlParams.get('collectionTarget');
if(collectionTarget){
  $('.CollectionMain').attr('data-collection-show-target', collectionTarget);
}

$(document).on('click', '[data-toggle-mobile-nav-collecttion]', function(e){
  e.preventDefault();
  e.stopPropagation();
  var target = $(this).data('toggle-mobile-nav-collecttion');
  $('.collection-mobile-submenu-2 a').removeClass('is-active');
  $(this).addClass('is-active');
  $('[data-collection-target]').hide();
  $('[data-collection-target="' + target + '"]').show();
  
});


// FAQ page
(function ($) {
  jQuery.expr[':'].Contains = function(a,i,m){
      return (a.textContent || a.innerText || "").toUpperCase().indexOf(m[3].toUpperCase())>=0;
  };

  function listFilter(header, list) { // header is any element, list is an unordered list
    // create and add the filter form to the header
    var form = $("<form>").attr({"class":"filterform","action":"#"}),
        input = $("<input>").attr({"class":"filterinput","type":"text"});
    $(form).append(input).appendTo(header);

    $(input)
      .change( function () {
        var filter = $(this).val();
        if(filter) {
          // this finds all links in a list that contain the input,
          // and hide the ones not containing the input while showing the ones that do
          $(list).find("a:not(:Contains(" + filter + "))").parent().slideUp();
          $(list).find("a:Contains(" + filter + ")").parent().slideDown();
        } else {
          $(list).find("li").slideDown();
        }
        return false;
      })
    .keyup( function () {
        // fire the above change event after every letter
        $(this).change();
    });
  }

  //ondomready
  $(function () {
    listFilter($("#header"), $("#list"));
  });
}(jQuery));

   /* NAHP-1184 Ajax cart page begining*/ 
$(document).ready(function() {
    $(".cart-qty").change(function(){
          Shopify.changeItem($(this).attr("itemId"), $(this).val());
    });
    Shopify.onCartUpdate = function (cart) {
      console.log(cart)
      if(cart.items.length > 0){
          cart.items.forEach(cartItem => {
          var element = $('div[data-item-id="' + cartItem.id + '"]');
          updateItemPrice(cartItem, element);
          });
          updateCart(cart);
      }else{
          window.location.reload()
      }
      }
    function updateItemPrice(cartItem, element){
      element.find('.CartItem__LinePrice.Price').text(Shopify.formatMoney(cartItem.line_price));
      element.find(".cart-qty").val(cartItem.quantity);
    }
    function updateCart(cart){
      $("span.cart-total-price").text(Shopify.formatMoney(cart.total_price));
      $(".Header__CartCount").text(cart.item_count);
    }
    
    $(".remove_cart_product").click(function(e){
      e.preventDefault();
      
      if($(this).attr("data-varient")){
        $(this).parents(".CartItem").remove();
          Shopify.removeItem($(this).attr("data-varient"));
      }
      });
    $(".cart-qty").click(function(e){
        e.stopPropagation(); 
        $(".drop-down").hide();
        $(this).parent().find(".drop-down").show();
      });
      
      $("div.qty-dropdown .qty-value").click(function(e){
        $(this).parents(".CartItem").find(".cart-qty").val($(this).text());
        $(this).parents(".CartItem").find(".cart-qty").trigger("change");
        $(".drop-down").hide();
      });
      
      $(document).click(function(){
        $(".drop-down").hide();
      });
      $(".QuantitySelector__CurrentQuantity").change(function(e){
        e.stopPropagation()        
      });
});
/* NAHP-1184 Ajax cart page end*/

/* Newsletter Section */
$('.get_on_top_newsletter .Newsletter.Form .Button').click( function(e) {
  $('.get_on_top_newsletter .Newsletter.Form .succes').hide();
  $('.get_on_top_newsletter .Newsletter.Form .error').hide();
  var sEmail = $('.get_on_top_newsletter .Newsletter.Form input[type="email"]').val();
  function validateEmail(sEmail) {
    var filter = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
    if (filter.test(sEmail)) {
      return true;
    }
    else {
      return false;
    }
  }

  if (validateEmail(sEmail)) {
    var newsletterCheckBoxContainer = $('[data-target="newsletterCheckBox"]');
    var newsletterCheckBox = $('[data-target="newsLetterCheckBox"]');
    var newsletterCheckBoxForm = $('[data-target="newsletterForm"]');

    if (!newsletterCheckBox.is(":checked")){
      $('.get_on_top_newsletter .Newsletter.Form').append('<p class="error">Check this box to sign up for updates from K-Y</p>');
      return false;
    } else {
      return true;
    }    
  }
  else {
    $('input[type="email"]').val('');
    $('.get_on_top_newsletter .Newsletter.Form').append('<p class="error">This email looks incomplete. Please check it and try again.</p>');
    return false;
  }
});

/* Footer Newsletter */
$('#section-footer #SubscribeFormFooter .Newsletter__Inner .Button').click( function(e){
  $('#section-footer .Newsletter .succes').hide();
  $('#section-footer .Newsletter .error').hide();
  var sEmail = $('#section-footer .Newsletter input[type="email"]').val();
  function validateEmail(sEmail) {
    var filter = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
    if (filter.test(sEmail)) {
      return true;
    }
    else {
      return false;
    }
  }

  if (validateEmail(sEmail)) {
    var newsletterCheckBoxContainer = $('[data-target="newsletterCheckBox"]');
    var newsletterCheckBox = $('[data-target="newsLetterCheckBox"]');
    var newsletterCheckBoxForm = $('[data-target="newsletterForm"]');
    if (!newsletterCheckBox.is(":checked")){
      $('#section-footer .Newsletter').append('<p class="error">Check this box to sign up for updates from K-Y</p>');
      return false;
    } else {
      return true;
    }    
  }
  else {
    $('#section-footer .Newsletter').append('<p class="error">This email looks incomplete.<br/> Please check it and try again.</p>');
    return false;
  }
});

$(document).ready(function() {
  $( ".size-label" ).bind({
    keydown: function(event) {
      if ( event.keyCode == 13 ) {
        $(this).click();
      }
    }
  });
  
  $( "span.QuantitySelector__Button.Link.Link--secondary" ).bind({
    keydown: function(event) {
      if ( event.keyCode == 13 ) {
        $(this).click();
      }
    },
    blur:function(event) {
      if($(this).attr('id') == 'add_qty'){
        $(this).attr('aria-label', 'Add quantity');
      }
      if($(this).attr('id') == 'subtract_qty'){
        $(this).attr('aria-label', 'Subtract quantity');
      }
    },
    click:function(enevt){
      if($(this).attr('id') == 'add_qty'){
        let quantity_val = $('input[name="quantity"]')
        $(this).attr('aria-label', 'Quantity added');
      }
      if($(this).attr('id') == 'subtract_qty'){  
        let quantity_val = $('input[name="quantity"]')
        $(this).attr('aria-label', 'Quantity subtracted');
      }
      $(this).attr('aria-pressed', 'true');
    }
  });
  
  $('span.QuantitySelector__Button.Link.Link--secondary').on('click',function(){
    var $this = $(this);
    window.setTimeout(function(){
      $this.removeAttr('aria-label');
    }, 500);
  });
  
  
  $( "ul.SizeSwatchList.HorizontalList li.HorizontalList__Item" ).bind({
    keydown: function(event) {
      if ( event.keyCode == 13 ) {
        $(this).find('.SizeSwatch').click();
      }
    }
  });
  
  $(document).on('click', 'ul.SizeSwatchList.HorizontalList li.HorizontalList__Item', function(event){
    setTimeout(function(){
      if($('.ProductForm__AddToCart').is('[disabled=disabled]')){
        $('.ProductForm__AddToCart').parents('.cart-add-btn-cnt').attr("tabindex", "0");
        $('.ProductForm__AddToCart').parents('.cart-add-btn-cnt').attr("title", "sold out");
      }else{
        $('.ProductForm__AddToCart').parents('.cart-add-btn-cnt').attr("tabindex", "-1");
      }
    }, 300);
  });
  
  $('ul.SizeSwatchList.HorizontalList li.HorizontalList__Item').click(function() {
    console.log("89999");
    $(".mikmak-discover").attr('data-mikmak-upcs', $(this).attr("data-upc").trim());
  });
  
  setTimeout(function(){
    $('.wc-container .wc-rating-question .wc-rating-question-text').attr('title', $('.wc-container .wc-rating-question .wc-rating-question-text').text());
    $('.wc-container .wc-rating-question .wc-rating-question-text').attr('tabindex', "0");
  	$('.template-article .shogun-heading-component h2').attr('tabindex', "0");
    $('.template-article .shogun-heading-component h3').attr('tabindex', "0");
  }, 3000);

  $('.productTabsNavItem').focus(function() {
    $('.wc-container .wc-rating-question .wc-rating-question-text').attr('title', $('.wc-container .wc-rating-question .wc-rating-question-text').text());
    $('.wc-container .wc-rating-question .wc-rating-question-text').attr('tabindex', "0");
  });
  
  
  $('a.PageSkipLink.u-visually-hidden').click(function() {
    $('#main').attr('tabindex', '0');
    $('#main').focus();
  });
  
  setTimeout(function(){
    $(".breadcrumb-social-media .social-sharing li:nth-child(1) a").attr("aria-label","K-Y Facebook Link");
    $(".breadcrumb-social-media .social-sharing li:nth-child(2) a").attr("aria-label","K-Y Twitter Link");
    $(".breadcrumb-social-media .social-sharing li:nth-child(3) a").attr("aria-label","K-Y Pinterest Link");
    $(".breadcrumb-social-media .social-sharing li:nth-child(4) a").attr("aria-label","Share by Email");
  }, 1500);  
});

$(document).ready(function() {
  $('.variants label.size-label').click(function() {
    console.log($(this).attr('data-available'));
    if($(this).attr('data-available') == 'true' ){
      $(this).parents('.variants').parent().find('.plp-sold-out-container').attr('tabindex', "-1");
    }else if( $(this).attr('data-available') == 'false'){
      $(this).parents('.variants').parent().find('.plp-sold-out-container').attr('tabindex', "0");
    }
  });
  
  setTimeout(function() {
    $('.template-collection .flex-center').each(function() {
      if ( ! $(this).hasClass('is-sold-out') ){
        $(this).find('.plp-sold-out-container').attr('tabindex', "-1");
      }
    });
    
    if( 768 < $(window).width() ){
      $('.Drawer__Content .Linklist__Item .Link').each(function() {
        $(this).attr('tabindex', '-1');
      });
    }
    
    $('.Product__Slideshow.Carousel.flickity-enabled.is-draggable').attr('title', $('.Product__Slideshow.Carousel.flickity-enabled.is-draggable').find('.Product__SlideItem.Product__SlideItem--image.Carousel__Cell.is-selected img').attr('alt'));
    $('.Product__Slideshow.Carousel.flickity-enabled.is-draggable').attr('tabindex', '-1');
    $('.Product__Slideshow.Carousel.flickity-enabled.is-draggable').find('.Product__SlideItem.Product__SlideItem--image.Carousel__Cell.is-selected img').attr('tabindex','0')
  }, 2000);
});

// To open external links in new tab
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
   /* links[i].target = '_blank';
    links[i].relList.add('noreferrer', 'noopener'); */
  }
}